import emergent from './phonics_json/emergent.json';
import pre_readers from './phonics_json/pre-readers.json';
import reading_fluency from './phonics_json/reading-fluency.json';
export const unit_map = [...pre_readers, ...emergent,...reading_fluency];